import { useEffect } from 'react'
import { ACTIVITY_COLORS, activityGeoJSON } from '../../utils/recentActivityData'

const SOURCE = 'recent-activity'
const HALO = 'recent-activity-halo'
const DOT = 'recent-activity-dot'

const colorExpression = ['match', ['get', 'category'],
  ...Object.entries(ACTIVITY_COLORS).flat(), '#d5b654']

export function useRecentActivity(map, { active, rows }) {
  useEffect(() => {
    if (!map.current || !map.current.getLayer('regions-fill')) return
    const data = activityGeoJSON(rows)
    let source = map.current.getSource(SOURCE)
    if (!source) {
      map.current.addSource(SOURCE, { type: 'geojson', data })
      map.current.addLayer({ id: HALO, source: SOURCE, type: 'circle', paint: {
        'circle-color': colorExpression, 'circle-radius': 14, 'circle-opacity': 0.22,
      } })
      map.current.addLayer({ id: DOT, source: SOURCE, type: 'circle', paint: {
        'circle-color': colorExpression, 'circle-radius': 5, 'circle-stroke-width': 2,
        'circle-stroke-color': '#ffffff', 'circle-opacity': 0.95,
      } })
      source = map.current.getSource(SOURCE)
    } else source.setData(data)
    for (const id of [HALO, DOT]) map.current.setLayoutProperty(id, 'visibility', active ? 'visible' : 'none')
    if (!active) return

    let frame
    const animate = (time) => {
      if (!map.current?.getLayer(HALO)) return
      const pulse = (Math.sin(time / 450) + 1) / 2
      map.current.setPaintProperty(HALO, 'circle-radius', 10 + pulse * 12)
      map.current.setPaintProperty(HALO, 'circle-opacity', 0.32 - pulse * 0.22)
      frame = requestAnimationFrame(animate)
    }
    frame = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(frame)
  }, [map, active, rows])
}
